<template>
  <div v-loading="loading">
    <div class="card table-header mt-4">
      <div class="flex justify-between">
        <!-- <div class="mr-2 filter">
          <img src="@/assets/images/icons/filter.svg" alt="filter icon" />
        </div> -->
        <router-link :to="{ name: 'OrganizationStructure' }">
          <button class="org-button">View Organization Structure</button>
        </router-link>
        <!-- <div class="table__search-input-wrapper">
          <span class="pr-2 opacity-50"><search-icon /> </span>
          <input
            type="text"
            class="table__search-input"
            placeholder="Search..."
            v-model="querySearch"
          />
          <img src="@/assets/images/icons/search.svg" alt="search icon" />
        </div> -->
        <!-- <router-link :to="{ name: 'CreateJobLevel' }"> -->
          <primary-button buttonText="Add Job Level" @click="showJobLevel = true"/>
        <!-- </router-link> -->
      </div>

      <div class="responsive-table" id="table-wrapper">
        <table class="custom-table responsive-table border-collapse">
          <thead>
            <tr class="shadow-table rounded-lg">
              <th class="checkbox">
                <base-checkbox />
              </th>
            <th>Category</th>
            <th>Level ID</th>
            <th>Description/Tag</th>
              <th tabindex="-1">
                <span class="cursor-pointer">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g opacity="0.7">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                        fill="#383F51"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                        fill="#383F51"
                      />
                    </g></svg
                ></span>
              </th>
            </tr>
          </thead>
          <tbody v-if="!loading">
            <tr v-if="!loading && filteredJobLevels.length == 0">
              <td class="shadow-table rounded-lg" colspan="5">
                <div v-if="!filteredJobLevels.length" class="flex flex-col gap-4">
                  <empty-job-level-icon />
                  <p class="text-center">
                    You can find job level categories of different branches of an organiasation here.          </p>
                  <a @click.prevent="showJobLevel = true" class="text-center text-sm font-bold" style="color: #fcc210">
                    <svg
                      width="22"
                      height="23"
                      viewBox="0 0 22 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      class="inline"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M11 22.4004C4.92487 22.4004 0 17.4755 0 11.4004C0 5.32526 4.92487 0.400391 11 0.400391C17.0751 0.400391 22 5.32526 22 11.4004C22 17.4755 17.0751 22.4004 11 22.4004ZM11 20.4004C15.9706 20.4004 20 16.371 20 11.4004C20 6.42983 15.9706 2.40039 11 2.40039C6.02944 2.40039 2 6.42983 2 11.4004C2 16.371 6.02944 20.4004 11 20.4004ZM16 10.4004H12V6.40039H10V10.4004H6V12.4004H10V16.4004H12V12.4004H16V10.4004Z"
                        fill="#FCC210"
                      />
                    </svg>
                    Create New Job Level
                  </a>
                </div>
              </td>
            </tr>
            <tr
              v-else
              v-for="joblevel in filteredJobLevels"
              :key="joblevel.id"
              class="shadow-table rounded-lg"
            >
              <td><base-checkbox  /></td>
              <td>{{ joblevel.category.name }}</td>
              <td>{{ joblevel.name }}</td>
              <td v-if="joblevel.tags.length > 0">
                <span v-for="tag in joblevel.tags" class="tag" :class="tag.name" :key="tag.id">{{ tag.name }}</span>
              </td>
              <td v-else>
                No Tags
              </td>                 
              <td
            tabindex="-1"
            @blur="selectedRowId = null"
            class="table__action-btn cursor-pointer"
          >
            <span @click="showActionOptions(joblevel.id)">
              <vertical-ellipsis />
            </span>
            <div class="table__action-options" v-if="selectedRowId == joblevel.id">
              <div
                class="table__action-option cursor-pointer"
                @click="editJobLevel(joblevel)"
              >
                <p>Edit</p>
              </div>
              <div
                class="table__action-option cursor-pointer"
                @click="showDelModal(joblevel)"
              >
                <p>Delete</p>
              </div>
            </div>
          </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination-control />
      <delete-modal :callback="deleteJobLevel" :deleteLoading="deleteLoading" name="Job Level" @deleted-action="getJobLevels" :showModal="showDeleteModal" @close-modal="showDeleteModal = false" />
      <new-job-level-modal v-if="showJobLevel"
      :showModal="showJobLevel"
      @close-modal="showJobLevel = false" />

      <edit-job-level-modal v-if="showEditJobLevel"
      :jobLevel="selectedJobLevel"
      :showModal="showEditJobLevel"
      @close-modal="showEditJobLevel = false" />
    </div>
  </div>
</template>

<script>

import PaginationControl from "@/components/UI/NewPagination";
import NewJobLevelModal from "./Modals/NewJobLevelModal";
import EditJobLevelModal from "./Modals/EditJobLevelModal";
import DeleteModal from "../DeleteModal";

export default {
  components: {
    PaginationControl,
    EditJobLevelModal,
    NewJobLevelModal,
    DeleteModal
  },
  data() {
    return {
      selectedRowId: null,
      jobLevels: [],
      selectedJobLevel: {},
      showDeleteModal: false,
      deleteLoading: false,
      loading: false,
      queryString: "",
      selectedId: "",
      showJobLevel: false,
      showEditJobLevel: false
    };
  },
  computed: {
    filteredJobLevels() {
      return this.filterArray(this.jobLevels, this.queryString);
    },
  },
  mounted() {
    this.getJobLevels();
  },
  methods: {
    async deleteJobLevel() {
      this.deleteLoading = true;
      alert(this.selectedId)
      try {
        const response = await this.$_deleteJobLevel(this.selectedId);
        this.log(response);
        this.generateToast(`JobLevel Deleted!`, "success");
        this.deleteLoading = false;
        this.showDeleteModal = false;
      } catch (error) {
        this.handleError(error);
      }
      this.deleteLoading = false;
    },
    showDelModal(model){
      this.showDeleteModal = true
      this.selectedId = model.id;
    },
    async getJobLevels() {
      this.loading = true;
      try {
        let response = await this.$_getJobLevels();
        console.log(response);
        this.jobLevels = response.data.levels;
        this.loading = false;
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },
    editJobLevel(jobLevel) {
      this.selectedJobLevel = jobLevel;
      localStorage.setItem("jobLevelToEdit", JSON.stringify(jobLevel));
      this.showEditJobLevel = true;
      // this.$router.push({ name: "EditJobLevel" });
    },
    
    showActionOptions(id) {
      if (!this.selectedRowId) {
        this.selectedRowId = id;
      } else {
        this.selectedRowId = null;
      }
    },
    resetSelectedRow() {
      this.selectedRowId = null;
    },
  },
};
</script>


<style lang="scss" scoped>
.kpis{
  background: #09B78A1A;
  color: #09B78A;
  padding: 5px;
}

tr:first-child td:first-child { border-top-left-radius: 10px; }
tr:first-child td:last-child { border-top-right-radius: 10px; }
tr:last-child td:first-child { border-bottom-left-radius: 10px; }
tr:last-child td:last-child { border-bottom-right-radius: 10px; }
.table__search-input-wrapper {  
  background: #7B858F10;
  width: 20vw;
}
.tag{
  padding: 0.5rem;
}
.color1{
  color: #09B78A;
  background: #09B78A1A;

}
.color2{
  color: #3454D1;
  background: #3454D11A;
}
.color3{
  background: #FCC210;  
  background: #FCC2101A;
}
table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}
.org-button{
  border: 1px solid #FCC210;
  padding: 0.5rem 1rem;
  border-radius: 0.4rem;
}
.actions {
  position: absolute;
  background: #ffffff;
  top: 3rem;
  right: 2rem;
  padding: 0.75rem;
  z-index: 999;
  font-size: 0.9rem;
  width: 10rem;

  background: #ffffff;
  /* Stroke */

  border: 1px solid #e7e7e9;
  box-sizing: border-box;
  box-shadow: 0px 20px 80px #dbd9d9;
  border-radius: 10px;

  span {
    padding-right: 0.25rem;
  }
  > div {
    display: flex;
    align-items: center;
    padding-bottom: 0.5rem;
  }
}
</style>

